import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const QuizProgressChart = () => {
  // Static data for testing
  const chartData = [
    { questionId: 'Q1', averageTime: 12, bestTime: 8 },
    { questionId: 'Q2', averageTime: 15, bestTime: 10 },
    { questionId: 'Q3', averageTime: 8, bestTime: 5 },
    { questionId: 'Q4', averageTime: 20, bestTime: 15 },
    { questionId: 'Q5', averageTime: 18, bestTime: 14 },
  ];

  return (
    <div className="w-full mt-8 h-64">
      <h3 className="text-lg font-semibold mb-4">Progress Statistics</h3>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="questionId" />
          <YAxis label={{ value: 'Time (seconds)', angle: -90, position: 'insideLeft' }} />
          <Tooltip />
          <Legend />
          <Bar dataKey="averageTime" name="Average Time" fill="#8884d8" />
          <Bar dataKey="bestTime" name="Best Time" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default QuizProgressChart;
